export default "__VITE_ASSET__BgGnrkw2__"